module.exports = __webpack_public_path__ + "img/DE00153.1259e743.png";